import React from 'react';
import styles from './MedicationOverviewSection.module.css';
import { CtgAnnotationComponent } from '../Components/CtgAnnotationComponent';
import classNames from 'classnames';
export var SectionContainer = function (props) {
    var validChildren = React.Children.toArray(props.children).filter(function (it) {
        return React.isValidElement(it) ? !it.props.hideSection : false;
    });
    var childrenCount = validChildren.length;
    if (childrenCount > 0) {
        return React.Children.map(validChildren, function (it, index) {
            return React.cloneElement(it, { border: index < childrenCount - 1, index: index + 1 });
        });
    }
    return null;
};
export var MedicationOverviewSection = function (props) {
    var _a;
    var _b, _c;
    if (props.hideSection)
        return null;
    var finalisedDetail = (_b = props.patientMedication) === null || _b === void 0 ? void 0 : _b.finalisedDetail;
    var ctgAnnotation = (finalisedDetail === null || finalisedDetail === void 0 ? void 0 : finalisedDetail.ctgAnnotation) ? finalisedDetail.ctgAnnotation : '';
    return (React.createElement("div", { className: styles.container },
        props.border && React.createElement("div", { className: styles.borderLine }),
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.index }, (_c = props.index) !== null && _c !== void 0 ? _c : 0),
            React.createElement("div", { className: classNames(styles.titleBlock, (_a = {}, _a[styles.hasSubTitle] = props.subTitle, _a)) },
                React.createElement("div", null,
                    React.createElement("span", { className: styles.title }, props.title),
                    !!props.showCtgAnnotation && React.createElement(CtgAnnotationComponent, { ctgAnnotation: ctgAnnotation })),
                !!props.subTitle && React.createElement("div", { className: styles.subTitle }, props.subTitle)),
            !!props.titleInput && React.createElement("div", { className: styles.titleInput }, props.titleInput)),
        !!props.children && React.createElement("div", { className: styles.body }, props.children)));
};
